const { isEmpty, sortBy, fromPairs, } = require('lodash');

const { entries } = Object;

const modelTypes = {
  fixedAsset: { label: '固定資産', },
  allowance: { label: '引当金', },
  bond: { label: '社債', },
  capital: { label: '資本', },
  debt: { label: '借入金', },
  investment: { label: '投資', },
  loan: { label: '貸付金', },
  fixedDeposit: { label: '定期預金', },
  otherLiability: { label: 'その他負債', },
  stockOption: { label: '新株予約権', },
  treasuryStock: { label: '自己株式', },
};

const fields = ({ existingLabels = [], } = {}) => {
  return {
    label: {
      label: '項目名',
      type: 'string',
      validations: {
        required: v => !isEmpty(v),
        unique: (v, s) => !existingLabels.includes(v),
      },
    },
  };
};

const filterByModelType = (customChangeFields = [], modelType) => {
  return sortBy(customChangeFields.filter(_ => _.modelType === modelType), 'order');
};

const hasChangeFieldValue = (items = [], key) => {
  return items.some(_ => _[key] != null && _[key] !== 0);
};

const composeOrderedKeys = (fixedLabels, customChangeFields = [], savedOrder, hiddenKeys = []) => {
  const fixedKeys = Object.keys(fixedLabels);
  const presetKeys = fixedKeys.filter(_ => _ !== 'other');
  const customKeys = customChangeFields.map(_ => _.id);
  const validKeys = new Set([...presetKeys, ...customKeys]);
  const ordered = savedOrder?.length
    ? [...savedOrder.filter(_ => validKeys.has(_)), ...presetKeys.filter(_ => !savedOrder.includes(_)), ...customKeys.filter(_ => !savedOrder.includes(_))]
    : [...presetKeys, ...customKeys];
  const hidden = new Set(hiddenKeys);
  const tail = fixedKeys.includes('other') ? ['other'] : [];
  return [...ordered.filter(_ => !hidden.has(_)), ...tail];
};

const composeChangeFieldNames = (fixedLabels, customChangeFields = [], savedOrder, hiddenKeys = []) => {
  return composeOrderedKeys(fixedLabels, customChangeFields, savedOrder, hiddenKeys);
};

const composeChangeFields = (fixedLabels, customChangeFields = [], savedOrder, hiddenKeys = []) => {
  const customLabelsById = fromPairs(customChangeFields.map(_ => [_.id, _.label]));
  const keys = composeOrderedKeys(fixedLabels, customChangeFields, savedOrder, hiddenKeys);
  return fromPairs(keys.map(k => [k, { label: fixedLabels[k] ?? customLabelsById[k], type: 'float' }]));
};

exports.modelTypes = modelTypes;
exports.fields = fields;
exports.filterByModelType = filterByModelType;
exports.hasChangeFieldValue = hasChangeFieldValue;
exports.composeChangeFieldNames = composeChangeFieldNames;
exports.composeChangeFields = composeChangeFields;
